import React, { Component } from 'react';

export default class StatusMessages extends Component {
  render() {
    const { type, message } = this.props;

    return (
      <div className="status-holder clearfix">
        {type === 'success' ? (
          <div className="alert alert-success">
            <i className="icon ion-checkmark-circled" /> {message}
          </div>
        ) : null}
        {type === 'error' ? (
          <div className="alert alert-danger">
            <i className="icon ion-close-circled" /> {message}
          </div>
        ) : null}
        {type == 'warning' ? (
          <div className="alert alert-warning">
            <i className="icon ion-android-alert" /> {message}
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StatusMessages.jsx